import { isAfter } from 'date-fns';

type DateValue = Date | string | number;

const isValidDate = (date: Date) => !isNaN(date.getTime());

export const getLatest = (...dates: DateValue[]): Date | undefined => {
  const dateObjects = dates.map((date) => new Date(date)).filter(isValidDate);

  if (dateObjects.length === 0) {
    return undefined;
  }

  return dateObjects.reduce((currentLatestDate, date) => {
    if (isAfter(date, currentLatestDate)) {
      return date;
    }

    return currentLatestDate;
  });
};
